import store from "../store";

/**
 * 检查是否有权限
 * @param perm
 * @returns {boolean}
 */
export function hasPerm(perm) {
  if (store.getters.isAdmin) {
    return true
  }
  const permissions = store.getters.permissions;
  if (Array.isArray(permissions)) {
    return permissions.indexOf(perm) > -1
  }
  return false
}





// WEBPACK FOOTER //
// ./src/utils/permission.js